// UploadStoryMedia.tsx
import * as SvgIcons from 'assets/svg/sprite'
import { type Orientation } from 'helpers/media'
import { FooterButton } from 'pages'
import { type StoryVideos, useUploadStoryMedia } from 'services/stories'

interface UploadStoryMediaProps {
  disabled?: boolean
  setImageData: (
    id: string | undefined,
    path: string,
    orientation: Orientation,
    exif_data: any
  ) => void
  setVideoData: (videos: StoryVideos) => void
  setProgressInfo: ((pct: number, cancelCb: () => void) => void) & ((reset: null) => void)
  clearMedia: () => void
  setMediaType: (mediaType: File | null) => void
  setThumbnail: (path: string) => void
  onTooManyFiles?: (count: number) => void
  onUploadError?: (message: string) => void
}

export const UploadStoryMedia = ({
  disabled = false,
  setImageData,
  setVideoData,
  setProgressInfo,
  clearMedia,
  setMediaType,
  setThumbnail,
  onTooManyFiles,
  onUploadError,
}: UploadStoryMediaProps) => {
  const { handleImageUploadClick, fileRef, handleSetUpload } =
    useUploadStoryMedia({
      setImageData,
      setVideoData,
      setProgressInfo,
      clearMedia,
      setMediaType,
      setThumbnail,
      onTooManyFiles,
      onUploadError,
    })

  const handleClick = () => {
    if (disabled) return
    handleImageUploadClick()
  }

  return (
    <>
      <FooterButton
        icon={<SvgIcons.IconImageOutline color="white" />}
        type="black--transparent"
        clickFn={handleClick}
        disabled={disabled}
      />

      <input
        ref={fileRef}
        type="file"
        id="story__media__upload"
        accept="image/*,video/mp4,video/x-m4v,video/*"
        hidden
        disabled={disabled}
        onClick={(e) => {
          if (disabled) {
            e.preventDefault()
            e.stopPropagation()
            return
          }

          e.currentTarget.value = ''
        }}
        onChange={(e) => {
          if (disabled) return
          handleSetUpload(e)
        }}
      />
    </>
  )
}